import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Contato.css';

const Contato = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ nome: '', email: '', telefone: '', motivo: '' });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t('contact.sent'));
    setForm({ nome: '', email: '', telefone: '', motivo: '' });
  };

  return (
    <section className="contato">
      <div className="container">
        <h2 className="contato-title">{t('contact.title')}</h2>
        <form className="contato-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nome">{t('contact.name')}</label>
            <input type="text" id="nome" name="nome" required value={form.nome} onChange={handleChange} placeholder={t('contact.name')} />
          </div>
          <div className="form-group">
            <label htmlFor="email">{t('contact.email')}</label>
            <input type="email" id="email" name="email" required value={form.email} onChange={handleChange} placeholder={t('contact.email')} />
          </div>
          <div className="form-group">
            <label htmlFor="telefone">{t('contact.phone')}</label>
            <input type="tel" id="telefone" name="telefone" required value={form.telefone} onChange={handleChange} placeholder={t('contact.phone')} />
          </div>
          <div className="form-group">
            <label htmlFor="motivo">{t('contact.reason')}</label>
            <textarea id="motivo" name="motivo" required value={form.motivo} onChange={handleChange} rows={4} placeholder={t('contact.placeholder')} />
          </div>
          <button className="btn btn-primary" type="submit">{t('contact.button')}</button>
        </form>
      </div>
    </section>
  );
};

export default Contato;
